<template>
  <div class="maintable" :class="isFlex ? 'flex-table' : ''" ref="maintable">
    <div class="header">
      <div>
        <slot name="left"></slot>
      </div>
      <div class="buttons">
        <slot name="buttons" class="btn-group"></slot>
      </div>
    </div>
    <div class="maintable-body" :class="showOutBorder ? 'out-border' : ''" ref="tableBody" :key="loadingBackground" v-loading="loading" :element-loading-background="loadingBackground" :element-loading-text="$i18.language('数据加载中')">
      <!-- <div :style="customerTablePage?`max-height:${tableHeightContent}!important;overflow: auto!important;margin-bottom:30px;margin-top:30px`:''"> -->
        <el-table  
        :class="[tableFixed?'table-fixed':'','table' , {'border-table-custome': border}]"
        ref="table"
        :border="border"
        :key="custoremTable?String(checkAll):String(checkAll) + String(checkIndeterminate) + String(showCheckbox) + defaultSortCom.prop + defaultSortCom.order"
        :data="tableData"
        :height="height ? height : isFlex ? tableHeight : undefined"
        :default-expand-all="false"
        :default-sort='defaultSortCom'
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        size="small"
        :cell-style="{ 'vertical-align': data.cotery }"
        @sort-change="changeSort"
        @selection-change="changeCheckBox"
        @row-click="rowClick"
        @expand-change="expandChange"
      >
        <!-- :row-key="function(row){return row.id}"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}" -->
        <!-- type="selection" -->
        <!-- <el-table-column
          v-if="tableColumn.length>0 && showCheckbox"
          width="30"
          align="right"
          header-align="right"
          class-name="checkbox-column"
          fixed
        ></el-table-column> -->
        <el-table-column type="expand" v-if="isExpand" fixed>
          <template slot-scope="scope">
            <slot name="expand" v-bind:scope="scope"></slot>
          </template>
        </el-table-column>
        <el-table-column type="expand" v-if="cgExpand" fixed width="28">
          <template slot-scope="scope">
            <slot name="suppliert" v-bind:scope="scope"></slot>
          </template>
        </el-table-column>
        <!-- 自定义索引 start-->
        <div v-if="custoremTable">
          <el-table-column v-if="tableColumn.length > 0 && showIndex" label="#" align="center" fixed header-align="center" min-width="50">
            <template slot-scope="scope">
              <span class="index">{{ (data.pageIndex - 1) * data.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
        </div>
        <!-- 自定义索引 end-->
        <el-table-column v-if="tableColumn.length > 0 && showCheckbox" align="center" fixed header-align="center" width="50">
          <template v-if="!loading" slot-scope="scope">
            <el-checkbox v-model="scope.row.check" :key="scope.row.check" @change="changeCheck(scope.row)"></el-checkbox>
          </template>
          <template slot="header" v-if="hedecok">
            <RetrofitCheckBox  v-if="retrofitCheckBox" :checkAll="isClickCheck?checkAll:false" 
              :indeterminate="isClickCheck?checkIndeterminate:false"
              :isClickCheck="isClickCheck"
              @changeAllCheck="changeAllCheck" :checkForm="checkForm" @eventChange="eventChange" ></RetrofitCheckBox>
            <el-checkbox :key="checkAll" v-model="checkAll" :indeterminate="checkIndeterminate" @change="changeAllCheck" v-else></el-checkbox>
          </template>
        </el-table-column>
        <!-- 自定义selection  企业  end-->
        <el-table-column v-if="tableColumn.length > 0 && companyMergeShowCheckbox" align="center" fixed header-align="center" width="50">
          <template v-if="!loading" slot-scope="scope">
            <el-checkbox v-model="scope.row.check" :key="scope.row.check" @change="changeCheck(scope.row)"></el-checkbox>
          </template>
          <template slot="header" v-if="hedecok">
            <el-checkbox :key="checkAll" v-model="checkAll" :indeterminate="checkIndeterminate" @change="changeAllCheck"></el-checkbox>
          </template>
        </el-table-column>
         <!-- 原始索引 start-->
        <div v-if="!custoremTable">
          <el-table-column v-if="tableColumn.length > 0 && showIndex && !showCustoremIndex" label="#" align="center" :fixed="indexFixed" header-align="center" min-width="40">
            <template slot-scope="scope">
              <span class="index">{{ (data.pageIndex - 1) * data.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
        </div>
        <div v-if="!custoremTable">
          <el-table-column v-if="tableColumn.length > 0 && showCustoremIndex" label="#" align="center" :fixed="indexFixed" header-align="center" width="60">
            <template slot-scope="scope">
              <span class="index">{{ (data.pageIndex - 1) * data.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
        </div>
         <!-- 原始索引 end-->
        <!-- 自定义表格  start -->
        <template v-if="custoremTable">
          <div v-for="(item, index) in tableColumn" :key="index">
            <el-table-column :key="index" v-if="item.type === 'name'" :label="item.title" :align="item.align ? item.align : 'center'" :header-align="item.headerAlign ? item.headerAlign : 'center'" :fixed="item.fixed" :min-width="item.width ? item.width : 100">
              <template slot-scope="scope">
                <label-item :type="nameType ? nameType : 'label'" :title="scope.row[item.key]" :isSelf="scope.row.is_now"></label-item>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              v-else-if="item.type === 'normal-name'"
              :label="item.title"
              :prop="item.key"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :fixed="item.fixed"
              :min-width="item.width ? item.width : 100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :key="index"
              v-else-if="item.type === 'customerlized'"
              :label="item.title"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :min-width="item.width ? item.width : 100"
              :fixed="item.fixed"
              :show-overflow-tooltip="!item.notTooltip"
            >
              <template slot-scope="scope">
                <slot :name="item.key" v-bind="scope" style="position:relative"></slot>
              </template>
              <template slot="header" v-if="item.isShowFilter||item.isShowSort">
                <div style="display: inline-block;" >
                  <span>{{ item.title }}</span>
                  <!-- 表头过滤组件 -->
                  <FilterPover 
                    :filterParams="filterParams" 
                    :rowParams="item"
                    @filterValue="filterValue"
                    @resetFilter="resetFilter"
                    @filterData="filterData"
                    @sortChange="sortChange"></FilterPover>
                </div>
              </template>
              <template slot="header" v-if="item.tips">
                <div style="display: inline-block">
                  <span>{{ item.title }}</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content" v-html="item.tips"></div>
                    <svg-icon class="tip-icon" name="tips"></svg-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :key="index" v-else-if="item.key === 'opration' && showOpration" :label="item.title" :align="item.align ? item.align : 'center'" :header-align="item.headerAlign ? item.headerAlign : 'center'" :min-width="item.width ? item.width : 100" :fixed="'right'">
              <template slot-scope="scope">
                <div class="opration">
                  <template v-for="(i, index) in item.items">
                    <div v-if="i.showKey ? i.showKey.value.includes(scope.row[i.showKey.key]) : true" @click.stop="oprationClick(i, scope.row)" :class="index === item.items.length - 1 ? 'last' : ''" class="oprate-item" :key="i.key">
                      <!-- <el-tooltip v-if="i.icon" class="item" effect="dark" :content="i.name" placement="top">
                      <svg-icon class="icon-fill" :name="i.icon"></svg-icon>
                    </el-tooltip> -->
                      <span>{{ i.name }}</span>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column :key="index" v-else-if="item.key === 'hide-opration' && showOpration" :label="item.title" :align="item.align ? item.align : 'center'" :header-align="item.headerAlign ? item.headerAlign : 'center'" :min-width="item.width ? item.width : 100" :fixed="'right'">
              <template slot-scope="scope">
                <div class="hide-opration">
                  <el-popover placement="right" title="" popper-class="hide-opration-popover" trigger="hover">
                    <div class="btns">
                      <div class="operation-btn" v-for="i in item.items" :key="i.key" @click="oprationClick(i, scope.row)">{{ i.name }}</div>
                    </div>
                    <!-- <i class="el-icon-arrow-right" slot="reference"></i> -->
                    <svg-icon name="more-icon" slot="reference"></svg-icon>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              v-else-if="item.key !== 'opration'"
              :label="item.title"
              :prop="item.key"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :fixed="item.fixed"
              show-overflow-tooltip
              :sortable="item.sort"
              :min-width="item.width ? item.width : 100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row[item.key] !== null && scope.row[item.key] !== undefined">
                  <span v-html="scope.row[item.key]"></span>
                </span>
                <span v-else>
                  <span> - </span>
                </span>
              </template>
              <template slot="header" v-if="item.tips">
                <div style="display: inline-block">
                  <span>{{ item.title }}</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content" v-html="item.tips"></div>
                    <svg-icon class="tip-icon" name="tips"></svg-icon>
                  </el-tooltip>
                </div>
              </template>
              <template slot="header" v-if="item.isShowFilter||item.isShowSort">
                <div style="display: inline-block;" >
                  <span>{{ item.title }}</span>
                  <!-- 表头过滤组件 -->
                  <FilterPover v-if="item.isShowFilter||item.isShowSort" 
                    :filterParams="filterParams" 
                    :key="item.keyName||item.key"
                    :rowParams="item"
                    @filterValue="filterValue"
                    @resetFilter="resetFilter"
                    @filterData="filterData"
                    @sortChange="sortChange"></FilterPover>
                </div>
              </template>
            </el-table-column>
          </div>
        </template>

        <!-- 自定义表格  end -->
        <!-- //原始表格结构 start-->
        <template v-else>
          <template v-for="item in tableColumn">
            <el-table-column :key="item.key" v-if="item.type === 'name'" :label="item.title" :align="item.align ? item.align : 'center'" :header-align="item.headerAlign ? item.headerAlign : 'center'" :fixed="item.fixed" :min-width="item.width ? item.width : 100">
              <template slot-scope="scope">
                <label-item :type="nameType ? nameType : 'label'" :title="scope.row[item.key]" :isSelf="scope.row.is_now"></label-item>
              </template>
            </el-table-column>
            <el-table-column
              :key="item.key"
              v-else-if="item.type === 'normal-name'"
              :label="item.title"
              :prop="item.key"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :fixed="item.fixed"
              :min-width="item.width ? item.width : 100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :key="item.key"
              v-else-if="item.type === 'customerlized'"
              :label="item.title"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :min-width="item.width ? item.width : 100"
              :fixed="item.fixed"
              :show-overflow-tooltip="!item.notTooltip"
            >
              <template slot-scope="scope">
                <slot :name="item.key" v-bind="scope"></slot>
              </template>
              <template slot="header" v-if="item.isShowFilter||item.isShowSort">
                <div style="display: inline-block;" >
                  <span>{{ item.title }}</span>
                  <!-- 表头过滤组件 -->
                  <FilterPover 
                    :filterParams="filterParams" 
                    :rowParams="item"
                    @filterValue="filterValue"
                    @resetFilter="resetFilter"
                    @filterData="filterData"
                    @sortChange="sortChange"></FilterPover>
                </div>
              </template>
              <template slot="header" v-if="item.tips">
                <div style="display: inline-block">
                  <span>{{ item.title }}</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content" v-html="item.tips"></div>
                    <svg-icon class="tip-icon" name="tips"></svg-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :key="item.key" v-else-if="item.key === 'opration' && showOpration" :label="item.title" :align="item.align ? item.align : 'center'" :header-align="item.headerAlign ? item.headerAlign : 'center'" :min-width="item.width ? item.width : 100" :fixed="'right'">
              <template slot-scope="scope">
                <div class="opration">
                  <template v-if="!scope.row.hasOwnProperty('page')">
                    <template v-for="(i, index) in item.items.filter(el=>!el.fold)">
                      <div v-if="i.showKey ? i.showKey.value.includes(scope.row[i.showKey.key]) : true" @click.stop="oprationClick(i, scope.row)" :class="index === item.items.length - 1 ? 'last' : ''" class="oprate-item" :key="i.key">
                        <!-- <el-tooltip v-if="i.icon" class="item" effect="dark" :content="i.name" placement="top">
                        <svg-icon class="icon-fill" :name="i.icon"></svg-icon>
                      </el-tooltip> -->
                        <span v-if="i.showName">{{ i.showName.name[i.showName.value.findIndex(e=>e===scope.row[i.showName.key])] }}</span>
                        <span v-else>{{ i.name }}</span>
                      </div>
                    </template>
                    <div v-if="item.items.filter(el=>el.fold).length" class="hide-opration">
                      <el-popover placement="right" title="" popper-class="hide-opration-popover" trigger="hover" :disabled="item.isShowType?!$url.btnDowloadPermission(item.isShowType)[0]:false">
                        <div class="btns">
                          <template v-for="i in item.items.filter(el=>el.fold)">
                            <div class="operation-btn" v-if="i.showKey ? (i.showKey.value.includes(scope.row[i.showKey.key])&&$url.btnDowloadPermission(getShowType(i.showKey.value,scope.row[i.showKey.key],i.showKey.isShowType))[0])?true:false : item.isShowType?$url.btnDowloadPermission(item.isShowType)[0]:true"  :key="i.key">
                              <el-link :underline="false" :disabled="i.showKey?$url.btnDowloadPermission(getShowType(i.showKey.value,scope.row[i.showKey.key],i.showKey.isShowType))[1]:item.isShowType?$url.btnDowloadPermission(item.isShowType)[1]:false" @click.stop="oprationClick(i, scope.row)" class="link-style">{{ i.name }}</el-link>
                            </div>
                          </template>
                        </div>
                        <span slot="reference">{{ $t('more') }}</span>
                      </el-popover>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="(i, index) in getItems(item.items,scope.row.searchTypeFrom)">
                    <div v-if="i.showKey ? i.showKey.value.includes(scope.row[i.showKey.key]) : true" @click.stop="oprationClick(i, scope.row)" :class="index === item.items.length - 1 ? 'last' : ''" class="oprate-item" :key="i.key">
                      <!-- <el-tooltip v-if="i.icon" class="item" effect="dark" :content="i.name" placement="top">
                      <svg-icon class="icon-fill" :name="i.icon"></svg-icon>
                    </el-tooltip> -->
                      <span>{{ i.name }}</span>
                    </div>
                    </template>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column :key="item.key" v-else-if="item.key === 'hide-opration' && showOpration" :label="item.title" :align="item.align ? item.align : 'center'" :header-align="item.headerAlign ? item.headerAlign : 'center'" :min-width="item.width ? item.width : 100" :fixed="'right'">
              <template slot-scope="scope">
                <div class="hide-opration">
                  <el-popover placement="right" title="" popper-class="hide-opration-popover" trigger="hover" :disabled="item.isShowType?!$url.btnDowloadPermission(item.isShowType)[0]:false">
                    <div class="btns">
                      <template  v-for="i in item.items">
                        <div class="operation-btn" v-if="i.showKey ? (i.showKey.value.includes(scope.row[i.showKey.key])&&$url.btnDowloadPermission(getShowType(i.showKey.value,scope.row[i.showKey.key],i.showKey.isShowType))[0])?true:false : item.isShowType?$url.btnDowloadPermission(item.isShowType)[0]:true"  :key="i.key">
                          <el-link :underline="false" :disabled="i.showKey?$url.btnDowloadPermission(getShowType(i.showKey.value,scope.row[i.showKey.key],i.showKey.isShowType))[1]:item.isShowType?$url.btnDowloadPermission(item.isShowType)[1]:false" @click.stop="oprationClick(i, scope.row)" class="link-style">{{ i.name }}</el-link>
                        </div>
                      </template>
                    </div>
                    <!-- <i class="el-icon-arrow-right" slot="reference"></i> -->
                    <svg-icon name="more-icon" slot="reference"></svg-icon>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :key="item.key"
              v-else-if="item.type === 'customerWidth'"
              :label="item.title"
              :prop="item.key"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :fixed="item.fixed"
              show-overflow-tooltip
              :sortable="item.sort"
              :width="item.width"
              :min-width="item.width ? item.width : 100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row[item.key] !== null && scope.row[item.key] !== undefined">
                  <el-tooltip  placement="top" ref="tooltip" v-if="!isShowTooltip">
                    <span v-html="formatHtml(scope.row[item.key])" slot="content"></span>
                    <span v-html="formatHtml(scope.row[item.key])" @mouseover="onMouseOver($event, scope.row[item.key])"></span>
                  </el-tooltip>
                  <span v-html="formatHtml(scope.row[item.key])" @mouseover="onMouseOver($event, scope.row[item.key])" v-if="isShowTooltip"></span>
                </span>
                <span v-else>
                  <span> - </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :key="item.key"
              v-else-if="item.key !== 'opration'"
              :label="item.title"
              :prop="item.key"
              :align="item.align ? item.align : 'center'"
              :header-align="item.headerAlign ? item.headerAlign : 'center'"
              :fixed="item.fixed"
              show-overflow-tooltip
              :sortable="item.sort"
              :min-width="item.width ? item.width : 100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row[item.key] !== null && scope.row[item.key] !== undefined">
                  <el-tooltip  placement="top" ref="tooltip" v-if="!isShowTooltip">
                    <span v-html="formatHtml(scope.row[item.key])" slot="content"></span>
                    <span v-html="formatHtml(scope.row[item.key])" @mouseover="onMouseOver($event, scope.row[item.key])"></span>
                  </el-tooltip>
                  <span v-html="formatHtml(scope.row[item.key])" @mouseover="onMouseOver($event, scope.row[item.key])" v-if="isShowTooltip"></span>
                </span>
                <span v-else>
                  <span> - </span>
                </span>
              </template>
              <template slot="header" v-if="item.tips">
                <div style="display: inline-block">
                  <span>{{ item.title }}</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content" v-html="item.tips"></div>
                    <svg-icon class="tip-icon" name="tips"></svg-icon>
                  </el-tooltip>
                </div>
              </template>
              <template slot="header" v-if="item.isShowFilter||item.isShowSort">
                <div style="display: inline-block;" >
                  <span>{{ item.title }}</span>
                  <!-- 表头过滤组件 -->
                  <FilterPover v-if="item.isShowFilter||item.isShowSort" 
                    :filterParams="filterParams" 
                    :key="item.keyName||item.key"
                    :rowParams="item"
                    @filterValue="filterValue"
                    @resetFilter="resetFilter"
                    @filterData="filterData"
                    @sortChange="sortChange"></FilterPover>
                </div>
              </template>
            </el-table-column>
          </template>
        </template>
        <!-- //原始表格结构 end-->

        <empty class="empty-table" slot="empty" :icon="emptyIcon" :title="emptyTitle"></empty>
        <slot name="columns"></slot>
      </el-table>

      <div  v-if="totalshow">
         <template>
        <el-table size="small" :data="totalData" :show-header="status" style="font-size: 12px,">
        <el-table-column
          label=""
          align="right"
          header-align="center"
          width="59"
          fixed
        >
          <template slot-scope="scope">
            <span class="index"></span>
          </template>
          </el-table-column> 
            <template v-for="item in tableuse" >
                <el-table-column :prop="item.key" :key="item.key" :label="item.title" :min-width="item.width ? item.width : 100"  :align="item.align ? item.align : 'center'">
                  <el-table-column v-if="item.key=='companyDetailCountSum'" align="center">
                    <template slot-scope="scope" >
                      <span class="index">{{scope.row.companyDetailCountSum}}</span>
                    </template>
                 </el-table-column> 
                   <el-table-column v-if="item.key=='tradeSearchCountSum'" align="center" >
                    <template slot-scope="scope" align="center">
                      <span class="countsum">{{scope.row.tradeSearchCountSum}}</span>
                    </template>
                 </el-table-column> 
                  <el-table-column v-if="item.key=='tradeDetailCountSum'" align="center" >
                    <template slot-scope="scope" align="center">
                      <span class="countsum">{{scope.row.tradeDetailCountSum}}</span>
                    </template>
                 </el-table-column> 
                  <el-table-column v-if="item.key=='concernCountSum'" align="center" >
                    <template slot-scope="scope" align="center">
                      <span class="countsums">{{scope.row.concernCountSum}}</span>
                    </template>
                 </el-table-column> 
                  <el-table-column v-if="item.key=='exportCompanyCountSum'" align="center" >
                    <template slot-scope="scope" align="center">
                      <span class="countsum">{{scope.row.exportCompanyCountSum}}</span>
                    </template>
                 </el-table-column> 
                </el-table-column>
            </template>
           
        </el-table>
    </template>
      </div>
      <!-- </div> -->
    </div>
    <div :class="[tableFixed?'maintable-footer-fixed':'','maintable-footer' ]" :style="footerStyle?'margin-bottom:-39px;height:58px;width:100%':''">
      <div class="footer-left">
        <!-- 批量删除文字 -->
         <span v-if="isShowDeleteBatches && tableData.length > 0" class="deleteBatchesText" @click="deleteBatchClick">{{this.$i18.language('批量删除')}}</span>
        <!-- 批量操作 -->
        <el-button v-if="showCheckMore && tableData.length > 0" :disabled="batchOperationBtnDisable" size="mini" class="sub-confirm-btn" @click="changeShowCheck">{{ $t("tableComponent.batchOperation") }}</el-button>
        <!-- 区间下载 -->
        <el-button v-if="showDsection && tableData.length > 0" :disabled="intervalDownloadBtnDisable" size="mini" class="sub-confirm-btn" @click="changeShowqujinxdel">{{ $t("tableComponent.intervalDownload") }}</el-button>
       
        <slot name="btns"></slot>
        <div v-if="showAnalyse" :id="'analyse'" class="icon" @click="analyse">
          <svg-icon :id="'analyse-icon'" name="area_chart"></svg-icon>
          <span>{{ $t("tableComponent.analysis") }}</span>
        </div>
        <div v-if="showDownload" class="icon" @click="download">
          <svg-icon name="download" style="width: 12px; height: 14px; margin-right: 4px"></svg-icon>
          <span>{{ $t("tableComponent.download") }}</span>
        </div>
        <el-input v-if="showSearch" class="search" size="mini" :placeholder="$t('tableComponent.search')" onfocus="this.placeholder=''" @keyup.enter.native="changeSearch" :maxlength="100" v-model="keyword">
          <i @click="changeSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!-- <div class="page" :style="customerTablePage?'margin-top:50px;':''"> -->
        <!-- 分页 -->
        <div class="page" >
        <!-- :class="data.total / data.pageSize > 5 ? 'hide-last' : ''" -->
        <el-pagination  
          v-if="showPage"
          :class="data.total / data.pageSize > 3000 ? 'hide-last' : ''"
          size="mini"
          :pager-count="quantityt"
          @size-change="changeSize"
          @current-change="changePage"
          :current-page.sync="currentPageIndex"
          :page-sizes="[5, 10, 20, 30, 50, 100]"
          :page-size="data.pageSize"
          :layout="pageLayout"
          :total="data.total"
          :key="updateKey"
        >
          <div key="1">
            <el-input class="jumperInput" type="number" v-model="curPageIndex" @keyup.enter.native="changePage(curPageIndex)" @blur="changePage(curPageIndex)"></el-input>
            <span class="totalPage">&emsp;/&emsp;{{ Math.ceil(data.total / data.pageSize) }}</span>
          </div>
        </el-pagination>
        <!-- <span>共{{ Math.ceil(data.total / data.pageSize) }}页</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import Empty from '@/components/empty.vue'
import FilterPover from '@/components/filterHeaderPover';
import i18n from '@/lang/index'
// import LabelItem from '@/components/Label.vue'
import { Form } from 'element-ui'
import RetrofitCheckBox from './RetrofitCheckBox.vue'; //表头复选框改成多种选择
export default {
  name: 'maintable',
  components: {
    Empty,
    FilterPover,
    RetrofitCheckBox
    // LabelItem
  },
  props: {
    footerStyle:{
      type: Boolean,
    },
    layout: {
      type: String
    },
    border: {
      type: Boolean,
      default: false,
    },
    // 索引是否固定
    indexFixed: {
      type: Boolean,
      default: true,
    },
     totalshow:{
      type: Boolean,
      required: false
    },
    custoremTable: {
      type: Boolean,
      default: false,
    },
    customerTablePage: {
      type: Boolean,
      default: false,
    },
    data: {
      required: true,
    },
    hedecok: {
      type: Boolean,
      default: true,
    },
    nameType: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showOutBorder: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    showIndex: {
      type: Boolean,
      default: true,
    },
    showCustoremIndex: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      // default: 450
    },
    isExpand: {
      type: Boolean,
      default: false,
    },
    cgExpand: {
      type: Boolean,
      default: false,
    },
    showOpration: {
      type: Boolean,
      default: true,
    },
    showCheckMore: {
      type: Boolean,
      default: false,
    },
    showDsection: {
      type: Boolean,
      default: false,
    },
    showAnalyse: {
      type: Boolean,
      default: false,
    },
    showDownload: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
      default: '',
    },
    quantityt: {
      type: Number,
      default: 7,
    },
    isFlex: {
      type: Boolean,
      default: false,
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    showPageSize: {
      type: Boolean,
      default: true,
    },
    showSmallPage: {
      type: Boolean,
      default: false,
    },
    tableFixed: {
      type: Boolean,
      default: false,
    },
    // 展示多样式按钮
    showMultiStyleButton: {
      type: Boolean,
      default: false
    },
    // 自定义样式，双行单行属性
    tableCss: {
      type: [Number, String],
      default: '',
    },
    batchOperationBtn:{ //是否展示批量操作按钮
      type:Boolean,
      default: false
    },
    intervalDownloadBtn:{ //是否展示区间下载按钮
      type:Boolean,
      default: false
    },
    batchOperationBtnDisable:{  //批量操作按钮是否禁用
      type:Boolean,
      default: false
    },
    intervalDownloadBtnDisable:{  //区间下载按钮是否禁用
      type:Boolean,
      default: false
    },
    isShowDeleteBatches:{ //是否展示批量删除文字
      type: Boolean,
      default: false
    },
    // 企业详细页合并企业显示多选框
    companyMergeShowCheckbox:{ 
      type: Boolean,
      default: false
    },
    // 是否自定义表头
    showTableHeader:{
      type: Boolean,
      default: false
    },
    //改造的表头复选框
    retrofitCheckBox:{
      type: Boolean,
      default: false
    },
    //全选完成有取消的数据存储以及勾选的数据存储
    checkAllContactData:{
      type: Object
    },
    //是否让最外面复选框点击
    isClickCheck:{
      type: Boolean,
      default: false
    },
    emptyIcon:{ //暂无数据图标
      type: String,
      default: 'no-data'
    },
    emptyTitle:{ //暂无数据文案
      type: String,
      default: i18n.t('message.noData')
    },
    defaultSort: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      updateKey: 0, //用来更新组件
      isShowTooltip: true, // 双行文本展示tooltip
      tableHeight: 0,
      tableHeightContent: 0,
      tableData: [],
      tableColumn: [],
      //合计
      totalData:[],
      status:false,
      tableuse:[],
      keyword: '',
      expands: [],
      getRowKeys(row) {
        return row.id
      },
      filterParams:{//要过滤的参数
        type:0,
        visible:false,
        checkOptions:[],
        chekList:[],//选中的集合
        activeSort:{
          dataType:'',
          sortType:''
        }
      },
      checkForm:{
        currentContact:false,
        allContact:false,
        indeterminateAll:false,//所有联系人半选中状态
        indeterminateCurrent:false,//当前联系人半选中状态
      },
      curPageIndex: 1,
      //是否显示序列号
      // isShowIndex: false,
      // checkAll: false,
      // checkIndeterminate: false
    }
  },
  computed: {
    currentPageIndex: {
      get() {
        return Number(this.data.pageIndex);
      },
      set(value) {
        this.curPageIndex = Number(value)
      }
    },
    loadingBackground() {
      return '#ffffffc4'
      // return this.$store.getters.loadingBackground
    },
    checkAll: {
      get() {
        //表头弹框里里面的复选框选中状态
        let result = this.tableData.length > 0 && this.tableData.findIndex(item => !item.check) < 0
        if(this.retrofitCheckBox){
          if(!this.isClickCheck){ //判断外面是不可以点击复选框
            if(!this.checkForm.allContact){ //当前的选择全部联系人没有选中
              this.checkForm.currentContact = result
              return this.checkForm.currentContact
            }
          }else{ //外面是可以点击复选框
            if(!this.checkForm.allContact){  //当全选联系人没有选中的时候 外层复选框同步状态同步页面里面的选中状态
              this.checkForm.currentContact =  result
            }
            return result
          }
        }else{
          return this.tableData.length > 0 && this.tableData.findIndex(item => !item.check) < 0
        }
      },
      set(val) {}
    },
    checkIndeterminate: {
      get() {
       let result =  this.tableData.length > 0 && !!this.tableData.find(item => !item.check) && this.tableData.findIndex(item => item.check) > -1
        if(this.retrofitCheckBox){ //表头改造的复选框
           if(!this.checkForm.allContact){ //当所有联系人复选框没有勾选
            this.checkForm.indeterminateCurrent = result
            return this.checkForm.indeterminateCurrent
           }else if(!this.checkForm.currentContact){ //当前页没勾选中
            this.checkForm.indeterminateAll = this.checkAllContactData.cancelAllContactsList.length>0 //全选的半选状态根据 取消存放的集合长度大于0说明全选里面有取消的
           }
        }else{
          return this.tableData.length > 0 && !!this.tableData.find(item => !item.check) && this.tableData.findIndex(item => item.check) > -1
        }
      },
      set(val) {}
    },
    pageLayout() {
      return this.layout ? this.layout : this.showPageSize ? 'total, sizes, prev, pager, next , jumper'  : 'total, prev, pager, next , jumper'
    },
    // 默认排序
    defaultSortCom: {
      get() {
        let data = this.defaultSort || { prop: this.data.sort, order: 'descending' }
        return data
      },
      set() {

      }
    }
  },
  created() {
    if (!this.height) {
      this.$nextTick(() => {
        this.tableHeight = this.$refs.tableBody.clientHeight - 33
        this.tableHeightContent=(document.documentElement.clientHeight-265)+'px'
        this.$refs.table.doLayout()
      })
    }
    // this.$nextTick(() => {
    //   this.$nextTick(() => {
    //     this.tableHeight = this.$refs.tableBody.clientHeight
    //   })
    this.tableData = this.data.result || []
    this.tableColumn = this.data.columnData || []
    this.sort = this.data.sort
    // this.$set(this, 'checkAll', this.data.data.findIndex(item => item.check === false) < 0)
    // })
  },
  methods: {
    //根据列表type字段值对应的权限匹配相关字段
    getShowType(list,serchType,showTypeList){
      let index=list.indexOf(serchType)
      if(index>-1){
        return showTypeList[index]
      }
    },
    getItems(val,searchTypeFrom){
      let item = Object.assign([],val)
       val=searchTypeFrom>-1? item.splice(1,item.length):val
       return val
    },
     parentHandleclick(val){
       this.totalData=[];
      if(this.totalData.length<1){
        this.totalData.push(val);
      };
    },
    changePage(val) {
      // 如果有小数点
      let rep = /[\.]/;
      if(rep.test(val)) {
        return this.curPageIndex = this.currentPageIndex;
      }
      // 如果跳转页大于最大页
      if (val > Math.ceil(this.data.total / this.data.pageSize)) {
        this.curPageIndex = val = this.currentPageIndex
      }
      this.$emit('change-page', val)
    },
    changeSize(val) {
      // this.pageTotal = val
      this.$emit('change-page-size', val)
    },
    // 当双行展示时多余文本显示...，同时显示tooltip
    onMouseOver(e, text) {
      this.isShowTooltip = true
      let overlength = this.$util.onMouseOver(e, text)
      overlength ? this.isShowTooltip = true : this.isShowTooltip = false
    },
    // 标准化字符串，当单行或双行展示时，替换掉字符串中的换行标签；自定义展示时完全展示
    formatHtml(str) {
      let value = str
      if(typeof(str) == 'string' && [1,2].includes(this.tableCss)) {
        value = str.replaceAll('<BR>', ' ')
      }
      return value
    },
    download() {
      this.$emit('download')
    },
    checkMore() {
      this.$emit('check-more')
    },
    analyse() {
      this.$emit('analyse')
    },
    changeCheck(data) {
      this.$emit('change-check', data)
      // this.checkIndeterminate = this.tableData.length > 0 && !!this.tableData.find(item => !item.check) && (this.tableData.findIndex(item => item.check) > -1)
      // this.checkAll = this.tableData.length > 0 && (this.tableData.findIndex(item => !item.check) < 0)
    },
    // 表头弹窗复选框触发事件
    eventChange(data,methodsWords,val){
      this[methodsWords](data,val)
    },
     //勾选当前页面联系人
     getCurrentContactCheck(item,val){
      this.changeAllCheck(val)
    },
    //勾选·获取全部联系人
    getAllContactCheck(data,val){
      console.log(data,val)
      //勾选全部联系人，取消勾选的当前页的状态及数据
      this.checkAll =  this.checkForm.currentContact =  this.checkForm.indeterminateCurrent = false
      this.checkForm.allContact = val
      this.checkForm.indeterminateAll = val
      //当前页置联系人置为false
      this.$emit('change-check-all',false)
      //当前所有联系人置为true
      this.$emit('select-all-contacts', val)
    },
    //清除所有选中数据
    clearAllContactCheck(data,val){
      this.checkForm.allContact = false
      this.checkForm.currentContact = false
      this.checkForm.indeterminateAll = false
      this.checkForm.indeterminateCurrent = false
      this.$emit('clear-check-all')
      this.$emit('change-check-all',false)
      this.$emit('select-all-contacts', false)
    },
    changeAllCheck(val) {
      //改造的表头复选框
      if(this.retrofitCheckBox){
        //如果全部联系人有勾选，取消勾选
        this.checkAll = this.checkForm.allContact = false
        this.checkForm.indeterminateAll = false
        this.$emit('select-all-contacts', this.checkForm.allContact)
        //选择的是当前页的联系人
        this.checkAll =  this.checkForm.currentContact = val
        this.checkIndeterminate = false
      }else{ //原来的
        this.checkAll = val
        this.checkIndeterminate = false
      }
      this.$emit('change-check-all', val)
    },
    changeCheckBox(val) {
      this.$emit('change-check', val)
    },
    changeSort(data) {
      this.filterParams.activeSort.dataType=''
      this.filterParams.activeSort.sortType=''
      this.$emit('change-sort', data.prop, data.order === 'descending' ? 'desc' : 'asc',data)
    },
    changeSearch() {
      this.$emit('change-search', this.keyword)
    },
    changeSearchNull() {
      this.$emit('change-search', '')
    },
    oprationClick(btn, row) {
      this.$emit(`${btn.key}-click`, row)
    },
    rowClick(row, column) {
      if (column&&column.title !== '操作') {
        this.$emit('row-click', row)
      }
    },
    expandChange(row, colum, event) {
      if (this.expands.includes(row.id)) {
        this.expands = this.expands.filter((val) => val !== row.id)
      } else {
        if (this.expands.length != 0) {
          this.expands.splice(0, this.expands.length)
          this.expands.push(row.id)
        } else {
          this.expands.push(row.id)
        }
      }
      this.$emit('expand-change', row)
    },
    changeShowCheck() {
      this.$emit('change-show-check')
      this.$emit('update:showCheckbox', !this.showCheckbox)
    },
    changeShowqujinxdel() {
      this.$emit('change-show-inxdel')
    },
    //点击批量删除文字
    deleteBatchClick(){
      this.$emit('delete-batch-click')
    },
    //排序
    sortChange(dataType,sortType){
      this.filterParams.activeSort.dataType = dataType
      this.filterParams.activeSort.sortType = sortType
      this.$emit('sort-change',dataType,sortType)
    },
      //过滤 
    filterValue(filterValue,optionList,val){
      this.$emit('filterValue',filterValue,optionList,val)
    },
  //重置过滤
    resetFilter(params,val,type, row){
      this.$emit('resetFilter',params,val,type, row)
    },
    filterData(params,val,type, row){
      this.$emit('filterData',params,val,type, row)
    },
  },
  watch: {
    data: {
      handler: function (data) {
        // this.$nextTick(() => {
        if (data.result && data.result.length > 0) {
          this.tableData = data.result
          this.tableColumn = data.columnData
          // this.checkIndeterminate = data.data.length > 0 && (data.data.findIndex(item => !item.check) > -1) && (data.data.findIndex(item => item.check) > -1)
          // this.checkAll = data.data.length > 0 && (data.data.findIndex(item => !item.check) < 0)
          if (data.sort) {
            this.sort = data.sort
          }
        } else {
          this.tableData = []
          if(this.showTableHeader){
            this.tableColumn = data.columnData
          }else{
            this.tableColumn = []
          }  
          this.checkAll = this.checkIndeterminate = false
          this.sort = null
        }
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      },
      deep: true,
    },
    'checkAllContactData.cancelAllContactsList'(newVal,oldVal){
        if(newVal.length>0){ //如果取消集合里面有数据，呈半选状态
          this.checkForm.indeterminateAll = true
        if(newVal.length == this.data.total){
          this.$emit('select-all-contacts', false)
           this.checkForm.allContact = false
           this.checkForm.indeterminateAll = false
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.border-table-custome {
  border: 0;
}
/deep/ .el-tooltip em {
  background-color: yellow !important;
  font-style: normal !important;
}
/deep/.el-checkbox__inner {
  border: 1px solid #cccfd4 !important;
}
.el-table__body {
  width: 100%;
  table-layout: fixed !important;
}
.customePage{
  margin-top:100px;
}
.maintable {
  &.flex-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: calc(100% - 60px);
    // width: 100%;
    .maintable-body {
      flex: 1;
      overflow: hidden;
      // height: 100%;
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
    }
  }
  .tip-icon {
    margin-left: 5px;
    cursor: pointer;
  }
  .header {
    display: flex;
    justify-content: space-between;
    /deep/.search {
      width: 200px;
      .el-input__suffix {
        cursor: pointer;
      }
    }
    /deep/.el-input {
      color: #969797;
      .el-input__inner {
        border: 1px solid #7a7b7f !important;
        background-color: transparent;
        color: #969797;
      }
      .el-input__prefix {
        i {
          color: #969797;
        }
      }
    }
    .buttons {
      .btns {
        min-height: 36px;
      }
    }
  }
  .maintable-body {
    // box-shadow: 0 0px 8px 1px rgba(0, 0, 0, 0.1) !important;
    // margin: 8px 8px 0 8px !important;
    &.out-border {
      border: 1px solid $--color-border-light;
      border-radius: 3px;
      border-bottom: none;
    }
    .opration {
      display: flex;
      line-height: 1;
      justify-content: center;
      color: $--color-link;
      .oprate-item {
        padding: 0 3px;
        // border-right: 1px solid $--color-link;
        cursor: pointer;
        &:last-of-type {
          border-right: none;
        }
        &.last {
          border-right: none;
        }
        &:hover {
          color: $--color-active-6;
        }
        .svg-icon {
          color: $--color-default;
        }
        span {
          text-decoration: none;
        }
      }
    }
    .hide-opration {
      .svg-icon {
        cursor: pointer;
      }
    }
    /deep/.el-table {
      font-family:-apple-system, "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "WenQuanYi Micro Hei", "Microsoft YaHei", sans-serif !important;
      // flex: 1;
      // overflow: hidden;
      /deep/.ratio-progress {
        .el-progress__text {
          font-size: 12px !important;
        }
      }
      &::before {
        display: none;
      }
      .el-table__expanded-cell {
        background-color: transparent;
      }
      .el-table__body-wrapper {
        // overflow: auto;
        .el-table__body-wrapper {
          .el-table__body {
            .el-table__row {
              .cell {
                .link {
                  color: $--color-primary !important;
                  cursor: pointer;
                }
              }
            }
          }
        }
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .el-table__fixed-right::before {
        background-color: transparent;
      }
      .checkbox-column {
        margin-right: 10px;
        .cell {
          padding: 0;
        }
      }
    }
  }
  .maintable-footer {
    display: flex;
    justify-content: space-between;
    padding-top: 8px;
    align-items: center;
    min-height: 29px;
    background: #fff;
    &.hide-search {
      justify-content: flex-end;
    }
    /deep/.search {
      width: 250px;
      .el-icon-search {
        cursor: pointer;
      }
    }
    .footer-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      .el-button {
        margin-right: 8px;
        margin-left: 0;
      }
      .icon {
        margin-right: 10px;
        height: 19px;
        cursor: pointer;
        .svg-icon {
          font-size: 18px;
        }
      }
    }
    .page {
      display: flex;
      align-items: center;
      font-size: 13px;
      background: #fff;
    }
    /deep/.el-pagination {
      display: flex;
      min-height: 28px;
      padding: 0;
      &.hide-last {
        .el-pager {
          .number {
            &:last-of-type {
              display: none;
            }
            // &:nth-child(5) {
            //   display: inline-block;
            // }
          }
        }
      }
      .jumperInput {
        width: 30px;
        /* google、safari */
        input::-webkit-outer-spin-button,  
        input::-webkit-inner-spin-button{  
          -webkit-appearance: none !important;  
          margin: 0;  
        }
        .el-input__inner{
          width: 30px;
          padding: 0;
        }
      }
      .totalPage {
        font-size: 13px;
        color: $--color-title;
      }
    }
  }
}
</style>
<style lang="scss">
.hide-opration-popover {
  min-width: unset;
  .btns {
    font-size: 12px;
    .operation-btn {
      padding: 5px 0;
      cursor: pointer;
      // color: $--color-link;
      &:hover {
        color: $--color-default;
      }
    }
  }
}
.warp{
  width:400px;
  height:400px;
  margin:20px auto;
  margin-top: 200px;
}
.warp .span2{
  color: #ddd;
  font-size: 14px;
}
.maintable-footer-fixed{
  position:fixed;
  right:20px;
  bottom:30px;
}
.table-fixed{
  height:450px!important;
}
.link-style{
font-size: 12px;
}
.link-style:hover{
  color: #ea5519 !important;

}
.deleteBatchesText{
  margin-left: 20px;
  color: $--color-primary-6;
  cursor: pointer;
}
.caret-wrapper {
  height: 20px!important;
}
.sort-caret.ascending {
  border-top: 0;
  top: 3px!important;
}
.sort-caret.descending {
  border-bottom: 0;
  bottom: 4px!important;
}
</style>
